import React from 'react';
import './Features.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const Features = () => {
  const { t, lang } = useLanguage();

  // Ürün grupları verisini dil değişimine göre (TR, EN, AR) dinamikleştiriyoruz kanka
  const productGroups = [
    {
      emoji: "🌾",
      title: lang === 'TR' ? "NIRVANA Akıllı Konsantre Yemler" : lang === 'AR' ? "أعلاف نيرفانا المركزة الذكية" : "NIRVANA Smart Concentrate Feeds",
      desc: lang === 'TR' ? "Süt, besi, buzağı ve at performans hedefleri için akıllı konsantre yem grubu." : lang === 'AR' ? "مجموعة أعلاف مركزة ذكية لأهداف أداء الألبان والتسمين والعجول والخيول." : "Smart concentrate feed group for milk, beef, calf and horse performance goals.",
      items: [
        "NIRVANA MILK", 
        "NIRVANA BEEF", 
        "NIRVANA CALF", 
        lang === 'AR' ? "نيرفانا طاقة الخيل" : "NIRVANA HORSE ENERGY"
      ]
    },
    {
      emoji: "🧪",
      title: lang === 'TR' ? "BIGMA Premiks Grubu" : lang === 'AR' ? "مجموعة بريمكس بيغما" : "BIGMA Premix Group",
      desc: lang === 'TR' ? "Büyükbaş, küçükbaş, kanatlı, at ve deve için vitamin-mineral premiksleri." : lang === 'AR' ? "بريمكسات الفيتامينات والمعادن للماشية والأغنام والدواجن والخيول والإبل." : "Vitamin-mineral premixes for cattle, sheep/goats, poultry, horses and camels.",
      items: [
        "DRYCOW PREMIX", 
        "FRESHCALVE PREMIX", 
        lang === 'TR' ? "Karaciğer destek" : lang === 'AR' ? "دعم الكبد" : "Liver support", 
        lang === 'TR' ? "Döl verimi premiksi" : lang === 'AR' ? "بريمكس الخصوبة" : "Fertility premix"
      ]
    },
    {
      emoji: "🐄",
      title: lang === 'TR' ? "VITACALF Buzağı Ürünleri" : lang === 'AR' ? "منتجات العجول فيتاكالف" : "VITACALF Calf Products",
      desc: lang === 'TR' ? "Buzağı maması, elektrolit, ishal pastası ve büyütme destekleri." : lang === 'AR' ? "بدائل ألبان العجول، الإلكتروليتات، معاجين الإسهال ودعامات النمو." : "Calf milk replacer, electrolyte, diarrhea paste and growth supports.",
      items: [
        lang === 'TR' ? "VITACALF Buzağı Maması" : lang === 'AR' ? "بديل لبن العجول فيتاكالف" : "VITACALF Calf Milk Replacer", 
        "VITACALF ELECTROLYTE", 
        lang === 'TR' ? "Buzağı pastaları" : lang === 'AR' ? "معاجين العجول" : "Calf pastes"
      ]
    },
    {
      emoji: "💧",
      title: lang === 'TR' ? "PALMCON Bypass Yağlar" : lang === 'AR' ? "دهون بالمكون المتجاوزة" : "PALMCON Bypass Fats",
      desc: lang === 'TR' ? "Kalsiyum sabunu bazlı enerji destek ürünleri." : lang === 'AR' ? "منتجات دعم الطاقة القائمة على صابون الكالسيوم." : "Calcium soap-based energy support products.",
      items: [
        "PALMCON CLASSIC", 
        "PALMCON PLUS", 
        lang === 'TR' ? "Lesitinli-enzimli formlar" : lang === 'AR' ? "أشكال الليسيثين والإنزيمات" : "Lecithin-enzyme forms"
      ]
    },
    {
      emoji: "🪣",
      title: lang === 'TR' ? "Yalama Kovaları ve Taşları" : lang === 'AR' ? "قوالب وأحجار اللعق" : "Licking Buckets and Blocks",
      desc: lang === 'TR' ? "Melas yalama kovaları, mineral kovalar ve 3 kg yalama taşları." : lang === 'AR' ? "دلاء لعق المولاس، دلاء المعادن وأحجار اللعق وزن 3 كجم." : "Molasses licking buckets, mineral buckets and 3 kg licking blocks.",
      items: [
        lang === 'TR' ? "Melas yalama kovası" : lang === 'AR' ? "دلو لعق المولاس" : "Molasses licking bucket", 
        lang === 'TR' ? "Mineral yalama kovası" : lang === 'AR' ? "دلو لعق المعادن" : "Mineral licking bucket", 
        lang === 'TR' ? "Yalama taşı TR:5800481" : lang === 'AR' ? "حجر لعق TR:5800481" : "Licking block TR:5800481"
      ]
    },
    {
      emoji: "🛡️",
      title: lang === 'TR' ? "Toksin Bağlayıcı ve Buffer" : lang === 'AR' ? "رابطات السموم والمنظمات" : "Toxin Binders and Buffer",
      desc: lang === 'TR' ? "Rumen pH, toksin bağlama ve sindirim destek çözümleri." : lang === 'AR' ? "حلول درجة حموضة الكرش، ربط السموم ودعم الهضم." : "Rumen pH, toxin binding and digestion support solutions.",
      items: [
        lang === 'TR' ? "Toksin bağlayıcı" : lang === 'AR' ? "رابط السموم" : "Toxin binder", 
        lang === 'TR' ? "Buffer ürünler" : lang === 'AR' ? "منتجات منظم الحموضة" : "Buffer products", 
        lang === 'TR' ? "MgO destekleri" : lang === 'AR' ? "دعامات أكسيد المغنيسيوم" : "MgO supports"
      ]
    },
    {
      emoji: "✨",
      title: lang === 'TR' ? "Sağım Hijyeni ve CIP" : lang === 'AR' ? "نظافة الحلب ونظام التنظيف المكاني" : "Milking Hygiene and CIP",
      desc: lang === 'TR' ? "Masti Clean alkali/asidik CIP, pre-dip ve film kaplı post-dip." : lang === 'AR' ? "منظفات ماستي كلين القلوية والحمضية، محاليل التطهير قبل وبعد الحلب." : "Masti Clean alkaline/acidic CIP, pre-dip and film-coated post-dip.",
      items: [
        lang === 'AR' ? "نظام CIP القلوي" : "Alkali CIP", 
        lang === 'AR' ? "نظام CIP الحمضي" : "Asidik CIP", 
        lang === 'AR' ? "التطهير قبل وبعد الحلب" : "Pre-Dip / Post-Dip"
      ]
    },
    {
      emoji: "🐎",
      title: lang === 'TR' ? "At ve Deve Ürünleri" : lang === 'AR' ? "منتجات الخيول والإبل" : "Horse and Camel Products",
      desc: lang === 'TR' ? "Enerji, kondisyon, elektrolit, premiks ve performans destekleri." : lang === 'AR' ? "دعامات الطاقة واللياقة والإلكتروليتات والبريمكس والأداء." : "Energy, condition, electrolyte, premix and performance supports.",
      items: [
        "NIRVANA HORSE ENERGY", 
        lang === 'TR' ? "At premiksi" : lang === 'AR' ? "بريمكس الخيول" : "Horse premix", 
        lang === 'TR' ? "Deve premiksi" : lang === 'AR' ? "بريمكس الإبل" : "Camel premix"
      ]
    },
    {
      emoji: "🐔",
      title: lang === 'TR' ? "Kanatlı Premiks ve Destek" : lang === 'AR' ? "بريمكس ودعم الدواجن" : "Poultry Premix and Support",
      desc: lang === 'TR' ? "Broyler ve yumurta tavukları için vitamin-mineral premiksleri." : lang === 'AR' ? "بريمكسات الفيتامينات والمعادن للدجاج اللاحم والبياض." : "Vitamin-mineral premixes for broilers and laying hens.",
      items: [
        lang === 'TR' ? "Broyler premiksi" : lang === 'AR' ? "بريمكس الفروج" : "Broiler premix", 
        lang === 'TR' ? "Yumurta tavuk premiksi" : lang === 'AR' ? "بريمكس الدجاج البياض" : "Layer hen premix", 
        lang === 'TR' ? "Performans destekleri" : lang === 'AR' ? "دعامات الأداء" : "Performance supports"
      ]
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <div className="features-header">
          <span className="header-badge">{t('features.badge')}</span>
          <h2>{t('features.title')}</h2>
          <p>{t('features.desc')}</p>
        </div>

        <div className="features-grid">
          {productGroups.map((group, index) => (
            <div key={index} className="product-card">
              <div className="product-emoji-box">
                {group.emoji}
              </div>
              <h3>{group.title}</h3>
              <p className="product-desc">{group.desc}</p>
              <ul className="product-list">
                {group.items.map((item, i) => (
                  <li key={i}>• {item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;